<template>
    <div class="container container--catalog">

        <Loader v-if="!isReady"></Loader>

        <List v-else class="list--products"
            :filtering="this"
            :itemNameSingular="'article'"
            :itemNamePlural="'articles'" >

            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
                
            </template>

            <template v-slot:filters>

                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher dans mes habitudes de commande"/>
                </ListFilter>
                <ListFilter>    
                    <Select v-model="filters.periodicity"
                        :options="periodicities">
                    </Select>
                </ListFilter>
                <ClientFilter v-model="filters.client_id"
                    :clients="clients"
                    :all="true" />
                <SiteFilter v-model="filters.site_id"
                    :clientAddresses="clientAddresses"
                    :markets="markets" />

            </template>

            <template v-slot:checkboxActions>
                <button class="woocommerce-button button alt"
                    :disabled="processing || !itemSelected || !hasContent"
                    v-on:click="buy()">
                    <span class="fa fa-shopping-cart"></span>
                    Ajouter au panier
                </button>
            </template>

            <template v-slot:heading>
                <div class="cell cell--cb">
                    <TogglerAll />
                </div>
                <div class="cell cell--ref">Réf.</div>
                <div class="cell cell--main">Produit</div>
                <div class="cell cell--secondary">U.V.</div>
                <div class="cell cell--price">Prix HT</div>
                <div class="cell cell--stat"><span v-if="hasContent">{{ formatPeriod(items[0].periods[0], filters.periodicity) }}</span></div>
                <div class="cell cell--stat"><span v-if="hasContent">{{ formatPeriod(items[0].periods[1], filters.periodicity) }}</span></div>
                <div class="cell cell--stat"><span v-if="hasContent">{{ formatPeriod(items[0].periods[2], filters.periodicity) }}</span></div>
                <div class="cell cell--actions">Actions</div> 
            </template>


            <ul class="list__content habit-list" v-if="hasContent">

                    <li v-for="category in categories"
                        :key="category.code">
                                    
                        <collapse :hidden="false" :selected="true">

                            <div slot="collapse-header">

                                <div class="list__content__sublist">

                                    <Category :data="category"/>

                                </div>
                            </div>

                            <div slot="collapse-body">

                                <ul class="list__content">

                                    <li class="list__content__item"
                                        v-for="item in category.items"
                                        :key="item.id">

                                        <ArticleHabit                  
                                            v-model="selectedItems"
                                            :data="item"
                                            :periodicity="filters.periodicity" />

                                    </li>

                                </ul>

                            </div>

                        </collapse>    
                        
                    </li>

            </ul>

            <div class="container_list container_list--no-result" v-if="!hasContent">
                    <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun article commandé récemment</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les articles suivants</button>
            </div>

        </List>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import ClientFilter from '@/components/list/filters/ClientFilter.vue'
import ArticleHabit from '@/components/articleHabit/ArticleHabit.vue'
import Button from '@/components/button/Button.vue'
import Category from '@/components/category/Category.vue'
import List, { ListFilter, TogglerAll }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import Select  from '@/components/select/Select.vue'
import SiteFilter from '@/components/list/filters/SiteFilter.vue'
import Collapse  from '@/components/collapse/Collapse.vue'

import api from '@/api/proxyWeb/stats'

import cart from '@/containers/cart.vue'
import filtering from "@/containers/filtering";
import selectAll from '@/containers/selectAll.vue'

import  { useCategories } from '@/helpers/category'
import  { useClientAddresses } from '@/helpers/clientAddress'
import  { useFormatPeriod } from '@/helpers/period'

export default {

    name: 'habitList',

    data: function() {
        return {
            filters: {
                client_id: null,
                periodicity: 'monthly',
                query: '',
                site_id: null,
            },
            processingXlsx: false
        }
    },

    computed: {

        categories: function() {

            return useCategories(this.items)
        },

        periodicities: () => {
            return [
                { value: 'monthly', name: "Mois" },
                { value: 'quarterly', name: "Trimestre" },
                { value: 'yearly', name: "Année" }
            ]  
        },

        ...mapState({

            clients: state => state.clients.all,

            clientAddresses: function(state) {
                return useClientAddresses(state.clients.all, this.filters.client_id)
            },

            markets: state => state.sites.markets,
        })
    },

    methods: {

        buy() {

            let articles = this.selectedItems.map(item => {
                    return {
                        'id': item.articleVariation.article.id,
                        'quantity': 1,
                        'variationId': item.articleVariation.id
                    }
                })

            this.addToCart(articles)
        },

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        },           

        formatPeriod(period) {
            return useFormatPeriod(period, this.filters.periodicity)
        }
    },  
  
    created () {
        this.useFilter(api)
    },

    watch: {

        items: function() {            
            this.selectableItems = []

            this.items.forEach(item => {
                if ( item.articleVariation.isPurchasable ) {
                    this.selectableItems.push(item)
                }
            })
        }
    },

    components: {
        ArticleHabit,
        Button,
        Category,
        ClientFilter,
        Collapse,
        List,
        ListFilter,
        Loader,
        Select,
        SiteFilter,
        TogglerAll
    },

    mixins: [ cart, filtering, selectAll ]
}
</script>

<style>

.habit-list .collapse .collapse-header::after {
  top: calc(50% - 0.2em);
}

</style>

<style scoped>

.list__content__sublist {
    width: 100%;
}

</style>